module.exports = __webpack_public_path__ + "images/formSubmited_bdb9f22.gif";